var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".search_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "search_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "search_svg__st1",
    d: "m21.22 19.81-3.38-3.38a8.594 8.594 0 0 0 1.86-5.33c0-4.74-3.86-8.6-8.6-8.6s-8.6 3.86-8.6 8.6 3.86 8.6 8.6 8.6c1.93 0 3.81-.66 5.33-1.87l3.38 3.38c.19.19.44.29.7.29.27 0 .52-.1.7-.29.19-.19.29-.44.29-.7s-.09-.51-.28-.7zM11.11 4.5c3.64 0 6.61 2.96 6.61 6.61a6.61 6.61 0 1 1-6.61-6.61z"
  })));
};
export default SvgSearch;